import * as React from "react"

import { cn } from "../../lib/utils"

function Card({
  className,
  style,
  ...props
}) {
  return (
    <div
      data-slot="card"
      className={cn(
        "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm",
        className
      )}
      style={{
        backgroundColor: 'hsl(var(--card))',
        color: 'hsl(var(--card-foreground))',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        borderRadius: '0.75rem',
        border: '1px solid hsl(var(--border))',
        paddingTop: '1.5rem',
        paddingBottom: '1.5rem',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        ...style
      }}
      {...props} />
  );
}

function CardHeader({
  className,
  style,
  ...props
}) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        className
      )}
      style={{
        display: 'grid',
        gridAutoRows: 'min-content',
        gridTemplateRows: 'auto auto',
        alignItems: 'start',
        gap: '0.5rem',
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',
        ...style
      }}
      {...props} />
  );
}

function CardTitle({
  className,
  style,
  ...props
}) {
  return (
    <div
      data-slot="card-title"
      className={cn("leading-none font-semibold", className)}
      style={{
        lineHeight: '1',
        fontWeight: 600,
        ...style
      }}
      {...props} />
  );
}

function CardDescription({
  className,
  ...props
}) {
  return (
    <div
      data-slot="card-description"
      className={cn("text-muted-foreground text-sm", className)}
      {...props} />
  );
}

function CardAction({
  className,
  ...props
}) {
  return (
    <div
      data-slot="card-action"
      className={cn(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        className
      )}
      {...props} />
  );
}

function CardContent({
  className,
  style,
  ...props
}) {
  return (
    <div 
      data-slot="card-content" 
      className={cn("px-6", className)} 
      style={{
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',
        ...style
      }}
      {...props} 
    />
  );
}

function CardFooter({
  className,
  ...props
}) {
  return (
    <div
      data-slot="card-footer"
      className={cn("flex items-center px-6 [.border-t]:pt-6", className)}
      {...props} />
  );
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
}
